import { render, staticRenderFns } from "./SocialButton.vue?vue&type=template&id=531e9a86&scoped=true&"
import script from "./SocialButton.vue?vue&type=script&lang=js&"
export * from "./SocialButton.vue?vue&type=script&lang=js&"
import style0 from "./SocialButton.vue?vue&type=style&index=0&id=531e9a86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531e9a86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VFlex,VIcon,VLayout,VRow})
